import { BiFilter } from 'react-icons/bi'

import { Circle } from '@chakra-ui/react'

import { Button } from '@/components/ui'

import { ButtonIProps } from '../Button/Button'

interface FilterButtonIProps extends ButtonIProps {
  filterCount: number
  onOpen: () => void
}

export const FiltersButton = ({
  filterCount,
  onOpen,
  ...rest
}: FilterButtonIProps) => {
  return (
    <Button
      h='40px'
      leftIcon={
        filterCount > 0 && (
          <Circle
            bgColor='#fff'
            color='#353849'
            fontSize='11px'
            h='20px'
            minW='20px'
            w='auto'
          >
            {filterCount}
          </Circle>
        )
      }
      {...rest}
      onClick={onOpen}
      px='6'
      rightIcon={<BiFilter size={24} />}
    >
      Filters
    </Button>
  )
}
